//require('./debug-info-modal.component.scss');
require('./database-usage-modal.component.scss');

export class DatabaseUsageModalController {
  constructor(
    $scope,
    $modalInstance,
    ServerInformationService,
    PermissionService,
  ) {
    $scope.close = () => {
      $modalInstance.close();
    };
    $scope.databaseUsage = ServerInformationService.databaseUsage;
    $scope.databasePath = ServerInformationService.databasePath;
    $scope.databaseUsageLimit = PermissionService.databaseUsageLimit;
  }
}



// WEBPACK FOOTER //
// ./src/admin/database-usage-modal.component.js